export const ML_UPDATE_STATE = "ML_UPDATE_STATE"
export const ML_UPDATE_CONFIG_DATA = "ML_UPDATE_CONFIG_DATA"
